import { useState } from "react";
import { toast } from "sonner";
import { Download, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const LBL = { patients: "Pacientes", treatments: "Tratamientos", altas: "Protocolos de alta", appointments: "Citas de agenda", profesionales: "Profesionales" };

const Resumen = ({ r }) => (
  <div data-testid="copia-resumen" className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm space-y-1">
    {Object.entries(r.resumen).map(([c, v]) => (
      <div key={c} className="flex justify-between gap-2"><span>{LBL[c] || c}</span><span className="font-[JetBrains_Mono] text-xs">{v.nuevos} nuevos · {v.distintos} con cambios</span></div>
    ))}
    {r.resumen.patients?.nombres_nuevos.length > 0 && <p className="text-[11px] text-slate-500">Nuevos: {r.resumen.patients.nombres_nuevos.join(", ")}</p>}
    {r.resumen.patients?.nombres_distintos.length > 0 && <p className="text-[11px] text-slate-500">Con cambios: {r.resumen.patients.nombres_distintos.join(", ")}</p>}
    {r.resumen.patients?.repetidos.length > 0 && <p className="text-[11px] text-amber-700" data-testid="copia-repetidos">Ya existen con el mismo nombre (no se importan, ni sus tratamientos): {r.resumen.patients.repetidos.join(", ")}</p>}
    {r.aparatos_en_conflicto?.length > 0 && <p className="text-[11px] text-rose-600">Aparatos ocupados por otro paciente (no cambiados): {r.aparatos_en_conflicto.join(", ")}</p>}
  </div>
);

export const CopiaDatos = () => {
  const [data, setData] = useState(null);
  const [r, setR] = useState(null);
  const [actualizar, setActualizar] = useState(false);
  const exportar = async () => {
    const { data: d } = await api.get("/admin/exportar");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([JSON.stringify(d)], { type: "application/json" }));
    a.download = `copia-datos-${d.exportado.slice(0, 10)}.json`;
    a.click();
  };
  const leer = async (file) => {
    try {
      const d = JSON.parse(await file.text()).data;
      setData(d);
      setR((await api.post("/admin/importar", { data: d, aplicar: false })).data);
    } catch {
      toast.error("El archivo no es una copia válida");
    }
  };
  const aplicar = async () => {
    if (!window.confirm(actualizar ? "Se añadirán los nuevos y se sustituirán los que tienen cambios por la versión del archivo. ¿Seguir?" : "Se añadirán solo los registros nuevos. ¿Seguir?")) return;
    const res = (await api.post("/admin/importar", { data, aplicar: true, actualizar })).data;
    setR(res);
    setData(null);
    toast.success("Datos importados");
  };
  return (
    <div className="space-y-3" data-testid="copia-datos">
      <p className="text-xs text-slate-500">Para pasar datos de la versión de pruebas a la publicada: descarga la copia aquí y súbela en la publicada. Nunca borra nada.</p>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={exportar} data-testid="copia-exportar"><Download className="h-4 w-4 mr-1" />Descargar copia de datos</Button>
        <label className="inline-flex items-center gap-1 rounded-md border border-slate-200 px-3 h-9 text-sm font-medium cursor-pointer hover:bg-slate-50">
          <Upload className="h-4 w-4" />Subir copia
          <input type="file" accept="application/json" className="hidden" data-testid="copia-archivo" onChange={(e) => e.target.files[0] && leer(e.target.files[0])} />
        </label>
      </div>
      {r && <Resumen r={r} />}
      {data && r && (
        <div className="flex flex-wrap items-center gap-3">
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" checked={actualizar} onChange={(e) => setActualizar(e.target.checked)} data-testid="copia-actualizar" className="h-4 w-4" />
            Actualizar también los que tienen cambios
          </label>
          <Button onClick={aplicar} data-testid="copia-aplicar" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Importar</Button>
        </div>
      )}
    </div>
  );
};
